var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6213_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28834 1.87605C6.28834 1.62959 6.48814 1.4298 6.7346 1.4298H9.25595C9.50241 1.4298 9.7022 1.62959 9.7022 1.87605V2.78324H6.28834V1.87605ZM5.53906 2.78324V1.87605C5.53906 1.21578 6.07432 0.680517 6.7346 0.680517H9.25595C9.91622 0.680517 10.4515 1.21578 10.4515 1.87605V2.78324H14.6603C14.8672 2.78324 15.0349 2.95097 15.0349 3.15788C15.0349 3.36479 14.8672 3.53252 14.6603 3.53252H13.879L13.8792 14.664C13.8792 15.7777 12.9764 16.6805 11.8627 16.6805H4.09695C2.9833 16.6805 2.08052 15.7777 2.08052 14.6641V3.53252H1.33973C1.13282 3.53252 0.965088 3.36479 0.965088 3.15788C0.965088 2.95097 1.13282 2.78324 1.33973 2.78324H5.53906ZM2.8298 3.53252H13.1297L13.1299 14.6641C13.1299 15.3639 12.5626 15.9312 11.8627 15.9312H4.09695C3.39712 15.9312 2.8298 15.3639 2.8298 14.6641V3.53252Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.25487V12.9215",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25487V12.9215",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6213_1106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.680664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/trash-outline.7961b282099dd176bb358f617818bbd9.svg";
export { ForwardRef as ReactComponent };